<template>
    <div :class="'caseDetail' + (isMobile? ' mobile':'')">
        <mHead :classType="'light'" :showBack="true" v-if="isMobile"></mHead>
        <pcHead v-else></pcHead>
        <div class="main">
            <div class="title">{{detail.caseName}}</div>
            <div v-if="isMobile" class="info">
                <div class="clear">
                    <span class="left">by {{detail.author}}</span>
                    <span class="right">{{detail.counts}}/浏览</span>
                    <span class="right">{{detail.createTime | formatDate('yyyy-MM-dd')}}</span>
                </div>
                <div class="labels">
                    <span class="label" v-for="item in labels" :key="item">#{{item}}</span>
                </div>
            </div>
            <div v-else class="info clear">
                <div class="left">
                    <span class="label" v-for="item in labels" :key="item">#{{item}}</span>
                    <span class="name">by {{detail.author}}</span>
                </div>
                <div class="right">
                    <span>{{detail.createTime | formatDate('yyyy-MM-dd')}}</span>
                    <span>{{detail.counts}}/浏览</span>
                </div>
            </div>
            <div class="content" v-html="detail.content">
            </div>
        </div>
        <mBottom v-if="isMobile" :classType="'light'"></mBottom>
        <pcBottom v-else></pcBottom>
    </div>
</template>

<script>
import pcHead from '@/components/base/pc/mHead.vue'
import pcBottom from '@/components/base/pc/mBottom.vue'
import mHead from '@/components/base/mobile/mHead.vue'
import mBottom from '@/components/base/mobile/mBottom.vue'
export default {
    name: 'caseDetail',
    components:{ pcHead, pcBottom, mHead, mBottom },
    data(){
        return {
            detail: {},
            labels: [],
        }
    },
    mounted(){
        this.getDetail();
    },
    methods: {
        statistics(caseName){
            this.$http.post(this.service.dev.api.statistics, {pageName: caseName} ).then(response =>{
              
            })
        },
        getDetail(){
            this.$http.get(this.service.dev.api.caseDetail + '?id=' + this.$route.params.id ).then(response =>{
              if(response.status == 200){
                  this.detail = response.body || {};
                  this.labels = this.detail.label.split(',')
                  this.statistics(this.detail.caseName);
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
          }).catch((res)=>{
              this.$message.error('error');
          })
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/style/base.scss";
    .caseDetail {
        background: #FAFAFA;
        &.mobile {
            background: #ffffff;
            .main {
                margin: poToRem(54) 0 0;
                width: 100%;
                max-width: unset;
                .title {
                    margin-top: poToRem(80);
                    font-size: poToRem(24);
                    font-weight: bold;
                    padding: 0 poToRem(20);
                    margin-bottom: poToRem(20);
                    text-align: left;
                }
                .info {
                    margin-left: poToRem(20);
                    padding: 0 poToRem(20) poToRem(40) 0;
                    text-align: left;
                    position: relative;
                    border-bottom: 1px solid rgba(0,0,0,0.1);
                    .clear span{
                        font-size: poToRem(16);
                        color: rgba(0,0,0,0.8);
                        &:nth-child(2) {
                            margin-left: poToRem(16);
                        }
                    }
                    .labels {
                        // padding-top: poToRem(12);
                        height: poToRem(20);
                    }
                    .label {
                        font-size: poToRem(12);
                        color: rgba(0,0,0,0.6);
                        margin-right: poToRem(12);
                    }
                }
                .content {
                    padding: poToRem(20) 0 poToRem(40);
                    margin-bottom: 0;
                }
            }
        }
        .main {
            width: 75%;
            margin: 0px auto 0;
            max-width: 1200px;
            .title {
                margin-top: 130px;
                font-size: 36px;
                margin-bottom: 40px;
            }
            .info {
                margin-bottom: 24px;
                .left {
                    .label {
                        font-size: 16px;
                        color: rgba(0,0,0,0.8);
                        margin-right: 12px;
                    }
                    .name {
                        margin-left: 10px;
                        font-size: 12px;
                        color: rgba(0,0,0,0.6);
                    }
                }
                .right {
                    span {
                        font-size: 12px;
                        color: rgba(0,0,0,0.6);
                        margin-left: 16px;
                    }
                }
            }
            .content {
                // margin-top: 24px;
                width: 100%;
                background: #ffffff;
                padding: 120px;
                box-sizing: border-box;
                color: rgba(0,0,0,0.6);
                margin-bottom: 80px;
                img {
                    margin-bottom: 24px;
                }
            }
        }
    }
</style>
<style lang="scss">
@import "@/assets/style/base.scss";
    .caseDetail {
        .main {
            .content {
                p,div {
                    color: rgba(0,0,0,0.6);
                    font-size: 16px;
                    text-align: left;
                }
                p {
                    line-height: 32px;
                }
                img {
                    width: 100vw;
                    display: block;
                }
            }
        }
        &.mobile {
            .content { 
                p,h1,h2,h3,h4,h5,ul,div {
                    padding: 0 poToRem(20); 
                }
                p,div {
                    font-size: poToRem(16);
                }
                p {
                    line-height: poToRem(32);
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/modules/view/case/detail.vue